import $$ from 'cmn-utils'

const baseUrl = "/api/safety/task/position/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    submit: (params) => {
        return $$.post(baseUrl + 'submit', params)
    },
    submitTemplateSubject: (params) => {
        return $$.post(baseUrl + 'submit-template-subject', params)
    },
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
}